import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Role, RolesLabelEnum} from '../shared/role.model';
import {RoleService} from '../shared/role.service';
import {CarrierService} from '../shared/carrier.service';
import {DataTableColumn} from '../../shared/data-table/data-table.component';
import {UserService} from '../shared/user.service';
import {Option} from '../../shared/data-filters/data-filter-select/data-filter-select.component';
import {finalize} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {LoaderService} from '../../shared/services/loader.service';
import {forkJoin} from 'rxjs';
import {Carrier} from '../shared/carrier.model';
import {SortDirection} from '../../shared/sort-direction';
import {UserSearchCriteria} from '../../shared/user-search-criteria';
import {SubcontractorService} from '../shared/subcontractor.service';
import {NavigationService} from '../../shared/services/navigation.service';
import {UserSearch} from '../shared/user-search.model';
import {SearchObjectResult} from '../../shared/search-object-result.model';
import {ErrorHandlerService} from '../../shared/services/error-handler.service';

@Component({
  selector: 'app-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.scss']
})
export class UserSearchComponent implements OnInit {

  public showFilters = true;
  public showAdvancedSearch = false;
  public direction = SortDirection.ASC;
  public formTitle = 'USER SEARCH';
  public maxNumberUserSearch = false;

  public rolesOptions: Option[];
  public carriersOptions: Option[];
  public subcontractorsOptions: Option[];
  public criteria: UserSearchCriteria = new UserSearchCriteria();
  public columns: DataTableColumn[] = [];
  public sortColumn: DataTableColumn;

  @ViewChild('emailColumn', { static: true })
  public emailColumn: TemplateRef<any>;

  @ViewChild('roleColumn', { static: true })
  public roleColumn: TemplateRef<any>;

  @ViewChild('carrierColumn', { static: true })
  public carrierColumn: TemplateRef<any>;

  @ViewChild('subcontractorColumn', { static: true })
  public subcontractorColumn: TemplateRef<any>;

  @ViewChild('statusColumn', { static: true })
  public statusColumn: TemplateRef<any>;

  loadPage = (page: number, pageSize: number, sortColumn: DataTableColumn, direction: SortDirection) =>
    this.userService.searchByCriteria(page - 1, pageSize, direction, this.criteria);

  constructor(
    private roleService: RoleService,
    private carrierService: CarrierService,
    private subcontractorService: SubcontractorService,
    private userService: UserService,
    private loader: LoaderService,
    private navigationService: NavigationService,
    private errorHandlerService: ErrorHandlerService,
  ) {}

  ngOnInit(): void {
    this.loader.startLoad(false);
    forkJoin([this.carrierService.getAll(), this.roleService.getAll()])
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(([carrier, roles]) => {
        this.initializeRolesOptions(roles);
        this.initializeCarriersOptions(carrier);
      }, (error: HttpErrorResponse) => {
        this.errorHandlerService.handleHttpError(error, 'user-dashboard.users.list.filters.criteria-init-option-error');
      });

    const emailColumn = {
        name: 'email',
        displayed: true,
        translationKey: 'user-dashboard.users.list.table.email',
        template: this.emailColumn,
        sortable: true
    };
    this.columns = [
      emailColumn,
      {
        name: 'role',
        displayed: true,
        translationKey: 'user-dashboard.users.list.table.roles',
        template: this.roleColumn,
        sortable: false
      },
      {
        name: 'carrier',
        displayed: true,
        translationKey: 'user-dashboard.users.list.table.carrier',
        template: this.carrierColumn,
        sortable: false
      },
      {
        name: 'subcontractor',
        displayed: true,
        translationKey: 'user-dashboard.users.list.table.subcontractor',
        template: this.subcontractorColumn,
        sortable: false
      },
      {
        name: 'status',
        displayed: true,
        translationKey: 'user-dashboard.users.list.table.status',
        template: this.statusColumn,
        sortable: false
      }
    ];
    this.sortColumn = emailColumn;
  }

  private initializeRolesOptions(roles: Role[]) {
    this.rolesOptions = roles != null && roles.length > 0 ? roles.map(r => ({ value: r.name, label: r.name })) : [];
  }

  private initializeCarriersOptions(carriers: Carrier[]) {
    this.carriersOptions = carriers != null && carriers.length > 0 ? carriers.map(c => ({ value: c.id, label: c.name })) : [];
  }

  public onSelectedCarrier() {
    if (this.criteria.carrierId) {
      this.subcontractorsOptions = [];
      this.subcontractorService.getCarrierSubcontractors(this.criteria.carrierId).subscribe((subcontractors) => {
        subcontractors.forEach(s => this.subcontractorsOptions.push({ value: s.id, label: s.name }))
      });
    }
  }

  public gotoCarrierPage(carrierId: string, roles: string[]): string  {
    if (roles.find(r => r === RolesLabelEnum.CARRIER_MANAGER)) {
      return this.navigationService.carriers().managers(carrierId).list().getUri();
    }
    return this.navigationService.carriers().drivers(carrierId).list().getUri();
  }

  public gotoSubcontractorPage(carrierId: string): string {
    return this.navigationService.carriers().subcontractors(carrierId).list().getUri();
  }

  resetCriteria() {
    this.criteria = new UserSearchCriteria();
  }

  checkMaxUser(result: SearchObjectResult<UserSearch>) {
    this.maxNumberUserSearch = result.totalCount > 1000;
  }
}
